import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const EvolveTshirtWhiteProduct = {
  title: "'Evolve' White T-shirt",
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/evolve-tee-white.png/w_1920',
  shopifyProductName: 'Evolve T-shirt',
  availableSizes: [
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const EvolveTshirtWhiteShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 95,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691327680754',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327680754:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691327746290',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327746290:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691327811826',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327811826:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691327877362',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327877362:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691327942898',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691327942898:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200402206816',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402206816:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200402272352',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402272352:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200402337888',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402337888:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200402403424',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402403424:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200402468960',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200402468960:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718623801404',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623801404:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718623866940',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623866940:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718623932476',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623932476:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718623998012',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718623998012:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718624063548',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718624063548:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1599,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40727785078854',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40727785078854:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40727785111622',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40727785111622:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40727785144390',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40727785144390:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40727785177158',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40727785177158:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40727785209926',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40727785209926:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 23,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202720244030',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720244030:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202720309566',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720309566:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202720375102',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720375102:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202720440638',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720440638:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202720506174',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202720506174:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 20,
        },
        [ShopifyStore.AU]: {
          price: 38,
        },
        [ShopifyStore.CA]: {
          price: 35,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 499,
        },
        [ShopifyStore.JP]: {
          price: 3800,
        },
      })
    : data_STAGING;
